export default function expandUploadPath(src?: any) {
  return !src
    ? ''
    : typeof src === 'string' && src.startsWith('uploads/')
      ? 'https://media2.vinciworks.com/wp-content/' + src
      : String(src);
}
